export default __webpack_public_path__ + "static/media/pause.f890539c.svg";